
import { Options } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { LayoutMixin } from "@/mixins/LayoutMixin";

@Options({
  components: {},
})
export default class GuestLayout extends mixins(LayoutMixin) {
  private get year(): number {
    return new Date().getFullYear();
  }

  protected toggleCookieSettings() {
    if (window.Optanon && typeof window.Optanon.ToggleInfoDisplay === 'function') {
      window.Optanon.ToggleInfoDisplay();
    } else {
      console.error("Optanon is not loaded or the function is not available.");
    }
  }
}
